import { createSelector } from '@reduxjs/toolkit';

import { countConfirmedForDate, countPendingForDate } from '../../domain/events/participants';
import type { RootState } from '../store';

export const selectFloorPlanConfirmedCount = createSelector(
  [
    (s: RootState) => s.auth.user?.telegramId,
    (s: RootState) => s.entities.events.items,
    (s: RootState) => s.ui.selectedDate,
  ],
  (telegramId, events, dateKey) => {
    return countConfirmedForDate(events, telegramId ?? '', dateKey);
  }
);

export const selectFloorPlanPendingCount = createSelector(
  [
    (s: RootState) => s.auth.user?.telegramId,
    (s: RootState) => s.entities.events.items,
    (s: RootState) => s.ui.selectedDate,
  ],
  (telegramId, events, dateKey) => {
    return countPendingForDate(events, telegramId ?? '', dateKey);
  }
);
